import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { AccountsVM } from './accounts.viewmodel';

const AccountsContext = React.createContext<AccountsVM>(null);
const connectAccountVM = makeConnect(AccountsContext);

export { AccountsContext, connectAccountVM };